import { List, ListItem, ListItemText, Typography } from '@mui/material';
import { FormikProvider, useFormikContext } from 'formik';
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import { HorizontalFlex } from '@components/RecordCard/RecordCard.style';

import { useCuration } from '@hooks/useCuration';
import { useSession } from '@hooks/useSession';

import RelatedRecordsButton from './RelatedRecordsButton';

const messages = defineMessages({
  save: {
    id: 'GLOBAL.save',
    defaultMessage: 'Save',
  },
  relatedRecords: {
    id: 'GLOBAL.relatedRecords',
    defaultMessage: 'Related Records',
  },
});

const RelatedRecordsForm: React.FC<{
  associations?: string[];
}> = ({ associations = [] }) => {
  const { formatMessage } = useIntl();
  const formik = useFormikContext();

  const {
    state: { isCurator },
  } = useSession();
  const {
    state: { isCreating },
  } = useCuration();

  if (isCurator && isCreating) {
    return (
      <FormikProvider value={formik}>
        <HorizontalFlex justifyContent="center">
          <Typography
            color="primary"
            variant="subtitle1"
            sx={{
              width: '100%',
              marginRight: '10px',
            }}
          >
            {formatMessage(messages.relatedRecords)}
          </Typography>
          <RelatedRecordsButton associations={associations} />
        </HorizontalFlex>

        <List dense>
          {associations.map((assoc) => (
            <ListItem disablePadding key={assoc}>
              <ListItemText primary={<Typography>{assoc}</Typography>} />
            </ListItem>
          ))}
        </List>
      </FormikProvider>
    );
  }

  return null;
};

export default RelatedRecordsForm;
